import { render, staticRenderFns } from "./RegisterPaymentModal.vue?vue&type=template&id=580a9ff3"
import script from "./RegisterPaymentModal.vue?vue&type=script&lang=js"
export * from "./RegisterPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports